module.exports = __webpack_public_path__ + "static/img/EU.917407c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/EU.svg
// module id = 2ktR
// module chunks = 66